import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {PlatformResponse} from 'src/app/interfaces/webservices-interface';
import {InAppBrowserObject} from '@ionic-native/in-app-browser/ngx';
import {Platform} from '@ionic/angular';
import {CustomerModel} from '../../../models/customer-model';
import {ConfigService} from '../../../services/config/config.service';
import {UserSessionService} from '../../../services/user-session/user-session.service';
import {WebservicesService} from '../../../services/webservices/webservices.service';
import {GameViewInterface,ODRController} from '../../odr-controller';
import {GameLaunchParams,VendorAdapterInterface} from './vendor-adapter-interface';

@Injectable()
export class PlayNGoAdapter implements VendorAdapterInterface {
  protected customer: CustomerModel;
  protected sessionToken: string;
  protected windowRef: InAppBrowserObject;

  constructor(
    private webservices: WebservicesService,
    private userSession: UserSessionService,
    private config: ConfigService,
    public platform: Platform,
    private telemetrySubject: Subject<any>
  ) {
    this.userSession.getCustomer().subscribe((customer) => {
      this.customer = customer;
      this.sessionToken = this.userSession.getSessionToken();
    });
  }

  public setWindowRef(windowRef: InAppBrowserObject | GameViewInterface): void {
    this.windowRef = windowRef as InAppBrowserObject;
  }

  public getWindowRef(): InAppBrowserObject | GameViewInterface {
    return this.windowRef;
  }

  public odrSessionId(): Subject<any> {
    return this.telemetrySubject;
  }

  public windowStrategy() {
    return "inappbrowser";
  }

  public shouldDescendIntoDirs() {
    return true;
  }

  public getTagLayout(extGameParams: GameLaunchParams): Promise<Array<any>> {
    return this.config.isLoaded().then( () => {
      let jurisdiction = ODRController.clientAppJurisdiction(this.config.getClientApp());
      var vendor = extGameParams.vendor;
      let tag = [vendor,jurisdiction,extGameParams.extGameType].join("-");

      let coretag = [vendor,"core"].join("-");
      return [
        { loc: "/gameloader", tag: coretag },
        { loc: "/#BUNDLENAME", tag: tag },
      ];
    });
  }

  public credentials(p: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.webservices
        .get("games/get-vendor-credentials", {
          customer_id: p.customer_id ? this.customer.customerId : null,
          session_token: p.session_token ? this.sessionToken : null,
          vendor: "playngo",
          game_launcher_id: p.gameLaunchId,
          clientapp: this.config.getClientApp(),
        })
        .subscribe(
          (resp: PlatformResponse<any>) => {
            console.log(resp);
            if (resp.code == "GAME_IN_PROGRESS") {
              reject({ gameLaunchId: resp.payload.game_launcher_id });
            } else {
              this.telemetrySubject.next(resp.payload.securetoken);
              resolve(Object.assign(p, resp.payload));
            }
          },
          (err: any) => {
            console.log("ODR: playngo: games/get-vendor-credentials error: ", err);
            reject(err);
          }
        );
    });
  }

  public launchODR(windowRef: InAppBrowserObject, gamePrms: any) {
    this.windowRef = windowRef;
    const server = this.config.getConfig().FEATURE_PLAYNGO_BASEURL;
    if(!server){
      console.error("playngo server is not configed");
      return
    }
    const paramObj = {
      lang: gamePrms.lang,
      gid: gamePrms.gid,
      pid: gamePrms.pid,
      ticket: gamePrms.ticket,
      practice: gamePrms.practice,
      channel: gamePrms.channel,
      origin: "http://localhost:9090",
      server: server
    };
    const params = Object.keys(paramObj)
      .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(paramObj[k])}`)
      .join("&");
    const url = "http://localhost:9090/gameloader/ContainerLauncher.html?" + params;

    windowRef.executeScript({
      code: `
            window.location.href = '${url}';
      `,
    });
    return windowRef;
  }

  public evaluateJavascript(js: string): Promise<any> {
    if (this.windowRef) {
      return this.windowRef.executeScript({
        code: js,
      });
    } else {
      return Promise.reject("ODR: playngo.ts: invalid windowRef");
    }
  }

  public onGameClosed(windowRef: InAppBrowserObject, closedCb: () => void) {
    windowRef.on("exit").subscribe((event) => {
      console.log("ODR: playngo.ts: onGameClosed");
      closedCb();
    });
  }
}
